
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m8.37 16 8-8","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"9.12","cy":"8.75","r":"1.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"15.62","cy":"15.25","r":"1.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M23.25 12a3.75 3.75 0 0 0-2.62-3.58 3.75 3.75 0 0 0-5-5 3.76 3.76 0 0 0-7.16 0 3.75 3.75 0 0 0-5 5.05 3.76 3.76 0 0 0 0 7.16 3.75 3.75 0 0 0 5.05 5 3.76 3.76 0 0 0 7.16 0 3.75 3.75 0 0 0 5-5A3.75 3.75 0 0 0 23.25 12Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    